import { useState } from 'react';
import axios from 'axios';

const ContactPage = () => {
  const [userName, setUserName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const [returnMesage, setReturnMessage] = useState('');

  // const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    let valid = true;
    let messageToReturn = '';
    setReturnMessage('');

    if (userName === '') {
      messageToReturn = 'Name is required. ';
      valid = false;
    }

    if (email === '') {
      messageToReturn = messageToReturn + 'Email is required. ';
      valid = false;
    } else if (!email.match(/^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/)) {
      messageToReturn = messageToReturn + 'Invalid Email Address. ';
      valid = false;
    }

    if (message === '') {
      messageToReturn = messageToReturn + 'Message is required.';
      valid = false;
    }

    if (valid) {
      await axios
        .post('/api/contactform', {
          userName: userName,
          userEmail: email,
          userMsg: message,
        })
        .then(function (response) {
          if (response.status === 200) {
            setReturnMessage(
              'Your query has been received, We will contact you soon.'
            );

            //reset the form on success
            setUserName('');
            setEmail('');
            setMessage('');
          } else {
            setReturnMessage('Your query could not be processed.');
          }
        })
        .catch(function (error) {
          setReturnMessage('Your query could not be processed..');
        });
    } else {
      setReturnMessage(messageToReturn);
    }
  };

  return (
    <>
      <section className="content-wrap">
        <h2>Free Consultation</h2>
        <h3>or to just drop us a line</h3>
        <div id="mainform">
          {/* <!-- Required Div Starts Here --> */}
          <form method="post" id="form" onSubmit={handleSubmit}>
            <p id="returnmessage">{returnMesage}</p>
            <p>
              All fields are required <span>*</span>
            </p>
            <label htmlFor="name">
              Name: <span id="name-info">*</span>
            </label>
            <input
              type="text"
              id="name"
              placeholder="Your Name"
              autoComplete="name"
              value={userName}
              required
              onChange={(e) => setUserName(e.target.value)}
            />
            <label htmlFor="email">
              Email: <span id="email-info">*</span>
            </label>
            <input
              type="text"
              id="email"
              placeholder="user@site.com"
              autoComplete="email"
              value={email}
              required
              onChange={(e) => setEmail(e.target.value)}
            />
            <label htmlFor="message">
              Message: <span id="message-info">*</span>
            </label>
            <textarea
              id="message"
              placeholder="What are you looking to do?"
              value={message}
              required
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
            <input
              type="button"
              id="submit"
              value="Send Message"
              onClick={handleSubmit}
            />
          </form>
        </div>
      </section>
    </>
  );
};

export default ContactPage;

/*
<script>
  $(document).ready(function() {
    $('#submit').click(function() {
      var valid = true;
      var name = $('#name').val();
      var email = $('#email').val();
      var message = $('#message').val();
      $('#returnmessage').empty(); // To empty previous error/success message.
      // Checking fields.

      if (name == "") {
        $("#name-info").html("* Required.");
        valid = false;
      } else {
        $("#name-info").html("*");
      }

      if (email == "") {
        $("#email-info").html("* Required.");
        valid = false;
      } else if (!email.match(/^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/)) {
        $("#email-info").html("Invalid Email Address.");
        valid = false;
      } else {
        $("#email-info").html("*");
      }


      if (message == "") {
        $("#message-info").html("* Required.");
        valid = false;
      } else {
        $("#message-info").html("*");
      }

      if (valid) {
        // Returns successful data submission message when the entered information is stored in database.
        $.post(
          'contact-process.php', {
            name1: name,
            email1: email,
            message1: message,
          },
          function(data) {
            $('#returnmessage').append(data); // Append returned message to message paragraph.
            if (
              data == 'Your Query has been received, We will contact you soon.'
            ) {
              $('#form')[0].reset(); // To reset form fields on success.
            }
          }
        );
      }
    });
  });
</script>
*/
